module.exports = __webpack_public_path__ + "images/bg-image.a69dc8be.webp";